import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { string, func } from "prop-types"

function FetchErrorScreen({ message, onRetry }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 64px)",
        gap: 2,
        textAlign: "center",
        px: 4
      }}
    >
      <Typography variant="h6" color="error">
        {message}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This is usually a temporary server issue. Please retry or reload the page.
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="contained" onClick={onRetry}>
          Retry
        </Button>
        <Button variant="outlined" onClick={() => globalThis.location.reload()}>
          Reload page
        </Button>
      </Box>
    </Box>
  )
}

FetchErrorScreen.propTypes = {
  message: string,
  onRetry: func
}

export default FetchErrorScreen
